"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MockOwner = void 0;
var MockOwner = exports.MockOwner = {
  'firstName': 'James',
  'surname': 'Bond',
  'name': 'James Bond',
  'dateofBirth': '2000-07-07',
  'titleCode': 'MR',
  'titleName': 'Mr',
  'genderName': 'Male',
  'genderId': 2,
  'address': '465 Victoria Ave',
  'suburb': 'CHATSWOOD',
  'state': 'NSW',
  'postcode': '2067',
  'telephoneHome': null,
  'telephoneWork': null,
  'telephoneMobile': '0412345678',
  'email': 'jamesb007@petsure.com.au',
  'dpid': '45756111',
  'barcode': '1301011112211220010101310313321033313',
  'authorisedMemberFirstName': null,
  'authorisedMemberSurname': null,
  'authorisedMemberDob': null,
  'authorizedDay': null,
  'authorizedMonth': null,
  'authorizedYear': null,
  'hasAuthorisePerson': false,
  'hasInsuranceCancelled': false,
  'isEmailCommunicaton': true,
  'clientNumbers': null,
  'marketingConsent': null,
  'fullAddress': '465 Victoria Ave, CHATSWOOD, NSW, 2067'
};